
/**
 * 全局权限，是否在DOM中移除该元素
 * 例如新增按钮的使用：v-permission="'add'"
 * 如果传入的是对象则指定：{ menuPerm: '希望获取的菜单的perm字段值', perm: '是否拥有的权限' }
 */
const permission = {
  mounted(el, binding) {
    let perm = binding.value;
    let menuPerm = ''

    if (typeof perm === 'object') { // 如果传入的是对象
      perm = binding.value.perm
      menuPerm = binding.value.menuPerm
    }

    const getPerms = (str, menus, isPerm) => {
      for (let i = 0; i < menus.length; i++) {
        if (isPerm && menus[i].perm === str) {
          return menus[i].children;
        }
        if (!isPerm && menus[i].path === str) {
          return menus[i].children;
        }
        if (menus[i].children) {
          let perms = getPerms(str, menus[i].children, isPerm);
          if (perms) return perms;
        }
      }

      return;
    };

    let menus = JSON.parse(window.localStorage.getItem("menu"));
    let perms = [];
    if (menuPerm) {
      perms = getPerms(menuPerm, menus, true);
    } else {
      let url = window.location.pathname.substr(5);
      perms = getPerms(url, menus);
    }

    let isShow = false;

    if (!perms || !perms.length) {
      isShow = false;
    } else {
      for (let i = 0; i < perms.length; i++) {
        if (perms[i].perm === perm) {
          isShow = true;
          break;
        }
      }
    }

    if (!isShow) {
      el.parentNode.removeChild(el);
      // el.style.display = "none";
    }
  },
};

export default {
  permission
}